import { Component, Inject, OnInit } from '@angular/core';
import { OrderChooserModalService } from '../../../../services/order-chooser-modal.service';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.css']
})
export class ProcessComponent implements OnInit {

  constructor(@Inject(OrderChooserModalService) private orderChooserModalService: OrderChooserModalService) { }

  openOrderChooser(): void {
    this.orderChooserModalService.open();
  }

  processpost = [
    {
      icon: "flaticon-online-booking",
      title: "Commander",
      text: ""
    },
    {
      icon: "flaticon-calories",
      title: "Cuisiner",
      text: ""
    },
    {
      icon: "flaticon-delivery-man",
      title: "Livrer",
      text: ""
    },
    {
      icon: "flaticon-food-tray",
      title: "Apprécier",
      text: ""
    }
  ]

  ngOnInit(): void {
  }

}
